import { HttpMethods } from "@/enums";
import { IRequestOptions } from "@/interfaces";

export const httpService = () => {
  const httpRequest = async (url: string, options: IRequestOptions) => {
    const { method, headers = {}, body, signal } = options;
    const csrfToken = document
      .querySelector("meta[name='csrf-token']")
      ?.getAttribute("content");

    const isFormData = body instanceof FormData;

    const defaultHeaders: Record<string, string> = {
      Accept: "application/json",
      "Cache-Control": "no-cache",
      "X-CSRF-TOKEN": csrfToken || "",
      ...headers,
    };

    if (!isFormData) {
      defaultHeaders["Content-Type"] = "application/json";
    }

    const response = await fetch(url, {
      method,
      headers: defaultHeaders,
      body: isFormData ? body : JSON.stringify(body),
      signal, // Pass the abort signal
    });

    if (!response.ok) {
      const errorMessage = await response.json();
      const msg = errorMessage?.message;
      const msgWithoutDate = msg.replace(
        /^\d{2}-\w{3}-\d{4}\s{2}\d{2}:\d{2}:\s/,
        "",
      );
      throw new Error(msgWithoutDate || "Something went wrong");
    }

    const responseData = await response.json();
    return responseData;
  };

  async function get(
    url: string,
    headers?: Record<string, string>,
    signal?: AbortSignal,
  ) {
    return httpRequest(url, { method: HttpMethods.GET, headers, signal });
  }

  async function post(
    url: string,
    body: any,
    headers?: Record<string, string>,
    signal?: AbortSignal,
  ) {
    return httpRequest(url, {
      method: HttpMethods.POST,
      body,
      headers,
      signal,
    });
  }

  async function put(
    url: string,
    body: any,
    headers?: Record<string, string>,
    signal?: AbortSignal,
  ) {
    return httpRequest(url, { method: HttpMethods.PUT, body, headers, signal });
  }

  async function _delete(url: string, headers?: Record<string, string>) {
    return httpRequest(url, { method: HttpMethods.DELETE, headers });
  }

  return {
    get,
    post,
    put,
    delete: _delete,
  };
};

export const HttpService = httpService();
